import React, { useMemo } from 'react';
import PickCarriersPageStore, { PageStoreContext } from 'store/pages/rfq/initiate-rfq/pick-carriers/pageStore';
import PickCarriersContent from 'components/rfq/initiate-rfq/pick-carriers';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';

const PickCarriersRFQPage = (): JSX.Element => {
  const pageStore = useMemo(() => new PickCarriersPageStore(), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <PickCarriersContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default PickCarriersRFQPage;
